import { render, staticRenderFns } from "./SearchPrice.vue?vue&type=template&id=75b8cb84&"
import script from "./SearchPrice.vue?vue&type=script&lang=ts&"
export * from "./SearchPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports